import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import SignupOrgPage from './pages/SignupOrgPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AppLayout from './layouts/AppLayout';
import MarketingShell from './layouts/MarketingShell';
import HomePage from './pages/marketing/HomePage';
import ToolsIndexPage from './pages/marketing/ToolsIndexPage';
import HeatSeederPage from './pages/marketing/HeatSeederPage';
import ComparePage from './pages/marketing/ComparePage';
import BlogIndexPage from './pages/marketing/BlogIndexPage';
import BlogPostPage from './pages/marketing/BlogPostPage';
import PrivacyPage from './pages/marketing/PrivacyPage';
import TermsPage from './pages/marketing/TermsPage';
import ContactPage from './pages/marketing/ContactPage';
import DashboardPage from './pages/DashboardPage';
import SetupWizardPage from './pages/SetupWizardPage';
import MeetsPage from './pages/MeetsPage';
import MeetDetailPage from './pages/MeetDetailPage';
import PrepareMeetPage from './pages/PrepareMeetPage';
import CoachPackPage from './pages/CoachPackPage';
import MeetDayPage from './pages/MeetDayPage';
import StudentsPage from './pages/StudentsPage';
import StudentDetailPage from './pages/StudentDetailPage';
import ParentsPage from './pages/ParentsPage';
import CoachesPage from './pages/CoachesPage';
import VenuesPage from './pages/VenuesPage';
import EventLibraryPage from './pages/EventLibraryPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import MyChildrenPage from './pages/MyChildrenPage';
import ProfilePage from './pages/ProfilePage';
import SuperAdminPage from './pages/SuperAdminPage';
import RoleGuard from './components/RoleGuard';

function ProtectedShell() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout />;
}

export default function App() {
  return (
    <Routes>
      {/* Public marketing routes (root) */}
      <Route element={<MarketingShell />}>
        <Route index element={<HomePage />} />
        <Route path="tools" element={<ToolsIndexPage />} />
        <Route path="tools/heat-seeder" element={<HeatSeederPage />} />
        <Route path="compare" element={<ComparePage />} />
        <Route path="blog" element={<BlogIndexPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>

      {/* Auth pages (no shell) */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupOrgPage />} />
      <Route path="/invite/:token" element={<AcceptInvitePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

      {/* Authenticated app */}
      <Route element={<ProtectedShell />}>
        <Route path="dashboard" element={<DashboardPage />} />

        <Route element={<RoleGuard roles={['admin', 'coach']} />}>
          <Route path="setup" element={<SetupWizardPage />} />
          <Route path="meets" element={<MeetsPage />} />
          <Route path="meets/:id" element={<MeetDetailPage />} />
          <Route path="meets/:id/prepare" element={<PrepareMeetPage />} />
          <Route path="meets/:id/coach-pack" element={<CoachPackPage />} />
          <Route path="meets/:id/day" element={<MeetDayPage />} />
          <Route path="students" element={<StudentsPage />} />
          <Route path="students/:id" element={<StudentDetailPage />} />
          <Route path="parents" element={<ParentsPage />} />
          <Route path="venues" element={<VenuesPage />} />
          <Route path="event-library" element={<EventLibraryPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
        </Route>

        <Route element={<RoleGuard roles={['admin']} />}>
          <Route path="coaches" element={<CoachesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route element={<RoleGuard roles={['parent']} />}>
          <Route path="my-children" element={<MyChildrenPage />} />
        </Route>

        <Route element={<RoleGuard roles={['super_admin']} />}>
          <Route path="super-admin" element={<SuperAdminPage />} />
        </Route>

        <Route path="profile" element={<ProfilePage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
